import styled from 'styled-components';

export const RemovePlaceholder = styled.span`
  display: inline-flex;
  width: 20px;
  height: 20px;
  vertical-align: text-bottom;
`;

export const ConditionContainer = styled.div`
  height: calc(100vh - 314px);
  overflow-y: auto;
  padding: 16px 28px 0 24px;

  color: rgba(0, 0, 0, 0.65);
  letter-spacing: -0.14px;
`;

export const ConditionRulesContainer = styled.div`
  padding: 8px 12px 8px 16px;
`;

export const ConditionRulesTitle = styled.div`
  color: #0046ff;
  line-height: 20px;
  padding-top: 4px;
`;
